module.exports = __webpack_public_path__ + "media/images/product/p_z-8dddf8d806961a307e97b26f7e729505.png";